export const maxSizeEachFileInMegaBytes = 15;
export const maxSizeAllFilesInMegaBytes = 50;

export const ftrStatus = {
  'in_progress': 'En progreso',
  'entered': 'Ingresado',
  'published': 'Publicado',
};

export const formsSections = {
  'chassis': {'icon': 'car', 'name': 'Chasis'},
  'electric_system': {'icon': 'power', 'name': 'Sistema Eléctrico'},
  'hibrid_system': {'icon': 'tune', 'name': 'Sistema Híbrido'},
  'motor': {'icon': 'settings', 'name': 'Motor'},
  'nvh': {'icon': 'ev_station', 'name': 'Nvh'},
  'transmission': {'icon': 'settings_input_component', 'name': 'Transmisión'},
  'special': {'icon': 'tag', 'name': 'Especiales'},
  'general': {'icon': 'settings', 'name': 'General'},
};
